import React from 'react';
import Button from '../../../components/ui/Button';
import { formatStr } from '../../../utils/formatStr';
import { formatPersianNumber } from '../../../utils/formatPersianNumber';

const TemplateCard = ({ template, onSelect }) => {
  return (
    <div className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group">
      <div className="h-2 bg-gradient-to-r from-purple-600 to-pink-600" />
      <div className="p-6">
        <div className="text-center mb-4">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-purple-100 to-pink-100 rounded-full mb-3 group-hover:scale-110 transition-transform">
            <span className="text-3xl">{template?.icon}</span>
          </div>
          <h3 className="text-xl font-bold text-gray-800 mb-1">
            {template?.name}
          </h3>
          <p className="text-sm text-gray-600">{template?.description}</p>
        </div>

        <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl p-4 mb-4 h-[270px] overflow-hidden">
          <p className="text-sm text-gray-700 leading-relaxed text-justify whitespace-pre-line">
            {formatStr(template?.value, '')}...
          </p>
        </div>

        <div className="flex items-center justify-between mb-4">
          <span className="text-sm text-gray-600">قیمت:</span>
          <span className="text-2xl font-bold text-purple-600">
            {formatPersianNumber(template?.price)}
            <span className="text-sm text-gray-600 mr-1">تومان</span>
          </span>
        </div>

        <Button
          onClick={() => onSelect(template)}
          className="w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-semibold"
        >
          انتخاب این قالب
        </Button>
      </div>
    </div>
  );
};

export default TemplateCard;
